var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-center"},[_c('div',{staticClass:"d-flex flex-column",staticStyle:{"width":"100%"}},[_vm._t("left_items")],2),_c('div',{staticClass:"ml-auto"},[_vm._t("right_items")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }